var LandersForeclosureModel =  function (defaultParams, extraParams) {
  this.data     = defaultParams;

  this.getData  = function () {
    return this.data;
  };

  this.extraData = function () {
    return extraParams;
  };
};

export { LandersForeclosureModel };



// WEBPACK FOOTER //
// ./landers_foreclosure/models/landers_foreclosure.js